import React, { useState, useEffect } from "react";

import { Row, Column } from "components/Layout";
import ElementModal from "./ElementModal";
import style from './_modal.module.scss';


export default function TrapInstallationModal({
	mode, onClose, onSubmit,
	installation, freeDevices, position, canSelectDevice = true
}) {

	const [deviceId, setDeviceId] = useState()
	const [lat, setLat] = useState()
	const [lng, setLng] = useState()
	const [description1, setDescription1] = useState()
	// const [description2, setDescription2] = useState()
	

	useEffect(() => {
		if (mode === 'update') {
			setLat(installation?.lat)
			setLng(installation?.lng)
			setDescription1(installation?.description1)
			// setDescription2(installation?.description2)
		} else { // mode 'create'
			if (freeDevices.length > 0) {
				setDeviceId(freeDevices[0]?.deviceId)
			}
			setLat(position?.latitude)
			setLng(position?.longitude)
			setDescription1("")
			// setDescription2("")
		}
	}, [mode, installation, position, freeDevices])

	function submit() {
		let newInstallation = {
			...installation,
			deviceSerial: deviceId,
			lat,
			lng,
			description1,
			// description2,
		}
		onSubmit(mode, newInstallation)
	}


	return (
		<ElementModal isOpen={!!mode} onClose={onClose} submit={submit}>
			<Column className={style.section}>
				<Row className={style.title}>
					Installazione Trappola
				</Row>
				{mode === 'create' && canSelectDevice &&
					<Row className={style.fields}>
						Seleziona dispositivo
						<select value={deviceId} onChange={e => setDeviceId(e.target.value)} >
							{freeDevices.map(d => 
								<option key={d.id} value={d.deviceId}>{d.label || d.deviceId}</option>
							)}
						</select>
					</Row>
				}
				
				<Row className={style.fields}>
					Latitudine
					<input
						type={"number"}
						onChange={e => setLat(e.target.value)}
						value={lat}
						step={0.001}
					/>
				</Row>
				<Row className={style.fields}>
					Longitudine
					<input
						type={"number"}
						onChange={e => setLng(e.target.value)}
						value={lng}
						step={0.001}
					/>
				</Row>

				<Row className={style.fields}>
					Descrizione
					<input
						type='text'
						placeholder={"Descrizione"}
						value={description1}
						onChange={e => setDescription1(e.target.value)}
					/>
				</Row>
				{/*
				<Row className={style.fields}>
					Trappola 2
					<input
						type='text'
						placeholder={"Descrizione"}
						value={description2}
						onChange={e => setDescription2(e.target.value)}
					/>
				</Row>
				*/}
			</Column>
		</ElementModal>
	)
}
